var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.00012,
    y: 2,
    width: 14,
    height: 12,
    rx: 1,
    stroke: "#008CFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00012 6H15.0001V8H1.00012V6Z",
    fill: "#008CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00012 -3.4969e-08C5.55241 -1.56561e-08 6.00012 0.447715 6.00012 1L6.00012 3C6.00012 3.55228 5.55241 4 5.00012 4C4.44784 4 4.00012 3.55228 4.00012 3L4.00012 1C4.00012 0.447715 4.44784 -5.42818e-08 5.00012 -3.4969e-08Z",
    fill: "#008CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 -3.4969e-08C11.5524 -1.56561e-08 12.0001 0.447715 12.0001 1L12.0001 3C12.0001 3.55228 11.5524 4 11.0001 4C10.4478 4 10.0001 3.55228 10.0001 3L10.0001 1C10.0001 0.447715 10.4478 -5.42818e-08 11.0001 -3.4969e-08Z",
    fill: "#008CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.c1c8435b66a48d726d513989f3bda115.svg";
export { ForwardRef as ReactComponent };